import { useQuery } from "@tanstack/react-query";
import CustomTable from "../common/CustomTable";
import {
  AttendanceMonthColumns,
  terminatedEmployeeCols,
} from "../../utils/table/attendanceCols";
import { getTerminatedEmployees } from "../../api/salary";

const TerminatedEmployeesModal = () => {
  const {
    isLoading,
    data: terminated_employees,
    isSuccess,
  } = useQuery({
    queryKey: ["terminated_employees"],
    queryFn: getTerminatedEmployees,
  });

  return (
    <div className="">
      {isLoading ? (
        "Loading"
      ) : isSuccess ? (
        <CustomTable
          data={terminated_employees}
          columns={terminatedEmployeeCols}
        />
      ) : (
        "Something went wrong"
      )}
    </div>
  );
};

export default TerminatedEmployeesModal;
